import { DatePicker, Form, FormInstance, Row } from "antd";
import { DATE_FORMAT } from "../../../../../lib/constants";
import { InfoCircleOutlined } from "@ant-design/icons";
import { ModalFooter } from "./ModalFooter";
import { usePayoffDateRule } from "../../../hooks/usePayoffDateRule";
import { useSendPayoff } from "../../../hooks/useSendPayoff";

type RequestsFormProps = {
  contractNumber: string;
  close: () => void;
};

export const RequestsForm = ({ contractNumber, close }: RequestsFormProps) => {
  const [form]: FormInstance[] = Form.useForm();

  const { rule } = usePayoffDateRule();

  const { send, isLoading } = useSendPayoff(contractNumber, form, close);

  return (
    <Row className="d-block requests-form w-100">
      <Form
        layout="vertical"
        requiredMark={false}
        className="pt-6"
        form={form}
        disabled={isLoading}
      >
        <Form.Item
          label="Intended Payoff Date"
          name="intendedPayoffDate"
          className="mb-6"
          rules={rule}
        >
          <DatePicker
            className="payoff-date"
            format={DATE_FORMAT}
            placeholder="MM/DD/YY"
            size="large"
          />
        </Form.Item>

        <Row className="align-start justify-space-between w-100 mb-2">
          <InfoCircleOutlined className="info-icon" />
          <div className="text-md description">
            3 payoff requests per calendar year are free, including those
            submitted outside the system. Additional requests will incur a{" "}
            <span className="text-md w-500">$20 fee</span>.
          </div>
        </Row>
        <Row className="align-start justify-space-between w-100">
          <InfoCircleOutlined className="info-icon" />
          <div className="text-md description">
            Quote preparation takes up to 3 business days. Once it’s ready
            you’ll get an email notification.
          </div>
        </Row>
      </Form>
      <ModalFooter isLoading={isLoading} send={send} close={close} />
    </Row>
  );
};
